import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Checkbox extends React.PureComponent {
  render() {
    const { className, name, size = 'full', invalid, checked, value, label, ...rest } = this.props;

    const classes = cx(className, styles.checkbox, styles[size], {
      [styles.invalid]: invalid,
    });

    return (
      <div className={classes}>
        <label key={label.value}>
          {label} <input type="checkbox" checked={checked} name={name} value={value} {...rest} />
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/form/checkbox.js